<template>
    <!-- Screenshots Section Start -->
    <section id="screenshot" class="screenshot padding-top-bottom">
        <div class="screenshot-decor">
            <div class="screenshot-circle1">
                <img
                    :src="require('../assets/images/feature-circle-two.png')"
                    alt="feature-circle-two"
                />
            </div>
            <div class="screenshot-circle2">
                <img
                    :src="require('../assets/images/feature-circle.png')"
                    alt="feature-circle"
                />
            </div>
            <div class="screenshot-circle3">
                <img
                    :src="require('../assets/images/main-banner1.png')"
                    alt="feature-circle-three"
                />
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12 ">
                    <div class="screenshot-contain">
                        <img
                            class="mobile-light-left"
                            :src="require('../assets/images/light.png')"
                            alt="light"
                        />
                        <img
                            class="mob-mocup img-fluid"
                            :src="require('../assets/images/screenshot-mob.png')"
                            alt="screenshot-mob"
                        />
                        <img
                            class="mobile-light-right"
                            :src="require('../assets/images/light-right.png')"
                            alt="light-right"
                        />
                        <b-carousel
                            v-model="slide"
                            :interval="4000"
                            no-animation
                            class="mx-auto"
                        >
                            <b-carousel-slide
                                :img-src="require('../assets/images/app/1.jpg')"
                                class="carousel-image"
                            ></b-carousel-slide>
                            <b-carousel-slide
                                :img-src="require('../assets/images/app/2.jpg')"
                                class="carousel-image"
                            ></b-carousel-slide>
                            <b-carousel-slide
                                :img-src="require('../assets/images/app/3.jpg')"
                                class="carousel-image"
                            ></b-carousel-slide>
                            <b-carousel-slide
                                :img-src="require('../assets/images/app/4.jpg')"
                                class="carousel-image"
                            ></b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Screenshots Section End -->
</template>
<script>
export default {
    name: "Screenshot"
}
</script>
<style>
.carousel-image {
  width: 200px !important;
  height: 355px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/screenshots.vue